export default __webpack_public_path__ + "static/media/logo-white.c1e021bb.svg";